import { FieldValues, useFormContext, useWatch } from 'react-hook-form'
import {
  componentNames,
  ENTITY_FIELDS,
  ENTITY_NAME,
  HYBRID_LAYOUT_CONSTANTS,
} from '../../utils/constants'
import { STRINGS } from '../../utils/strings'
import CategoryInput from '../common/CategoryInput'
import {
  DropdownType,
  fetchCommunicationIdCorrespondingData,
  getGenericEntityListingAPI,
  GetGenericEntityListingApiType,
} from '@app-store'
import { useEffect, useState } from 'react'
import { useAppSelector } from '../../utils/agent.store'
import {
  ExceptionIdcCodesCustomComponentPropsType,
  HybridLayoutDefaultFieldViewValPropsType,
} from './hybridLayout.types'
import { ElementType } from '../../types/layout.types'
import { ControlledMultiSelect } from '@ui-kit'
import React from 'react'
import { useParams } from 'react-router-dom'
import { getCaseKeyCaseNameByEntity } from '../../apis/entityData.api'

const HybridLayoutFieldCategoryFieldViewVal: React.FC<
  HybridLayoutDefaultFieldViewValPropsType
> = ({ element }) => {
  const catageoryValue = useAppSelector(
    (state) => state.categoryDropdown?.categoryMap
  )
  const valWatch = useWatch({ name: element?.keyName })
  const [val, setVal] = useState<string>('--')
  useEffect(() => {
    if (!valWatch?.id) {
      return
    }
    const list = catageoryValue?.['Yes No'] || []
    const catVal = list.find((cat) => cat.id === valWatch?.id)
    setVal(catVal?.value ?? '--')
  }, [catageoryValue, valWatch])
  return <div className="text-xs font-extraLight">{val}</div>
}

export const ApplicationVersionCustomComponent = ({
  mode,
}: {
  mode: string | undefined
}) => {
  const element: ElementType = {
    meta: {
      label: STRINGS.APPLICATION_VERSION,
      required: false,
      description: '',
    },
    keyName: `${HYBRID_LAYOUT_CONSTANTS.NESTING_DATA_KEY}.${ENTITY_NAME.CASE_PAP_DETAILS}.${ENTITY_FIELDS?.CASE_PAP_DETAILS?.acceptable_application_version}`,
    id: 1,

    elementId: 'uuid',
    elementName: componentNames.CATEGORY,
  }
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext()

  return (
    <div>
      {mode === 'view' ? (
        <div className="font-primary font-light">
          <label
            htmlFor={element?.keyName}
            className="text-sm font-normal mb-1 block"
          >
            {element?.meta?.label}
          </label>
          <div className="text-xs font-extraLight">
            {/* {getValues(element?.keyName) || '-'} */}
            <HybridLayoutFieldCategoryFieldViewVal element={element} />
          </div>
        </div>
      ) : (
        <CategoryInput
          name={element.keyName}
          label={element.meta.label}
          control={control}
          isSearchable={true}
          onChange={(e: DropdownType<string>) => {
            setValue(element.keyName, e?.value)
          }}
          setValue={setValue}
          categoryKey={'Yes No'}
          dataQaId={element.keyName ?? ''}
          required={true}
          errors={errors}
        />
      )}
    </div>
  )
}
export const ExceptionIdcCodesCustomComponent: React.FC<ExceptionIdcCodesCustomComponentPropsType> =
  React.memo(({ mode, task }) => {
    const [isVisibleIcdCodes, setisVisibleIcdCodes] = useState<boolean>(false)
    const { caseId } = useParams()
    const { control, setValue, getValues } = useFormContext()
    const [IcdOptions, setIcdOptions] = useState<DropdownType<string>[]>([])
    const element: ElementType = {
      meta: {
        label: STRINGS.ICDCODE,
        required: false,
        description: '',
      },
      keyName: STRINGS.ICD_CODE,
      id: 1,

      elementId: 'uuid',
      elementName: componentNames.MULTI_SELECT_DROPDOWN,
    }

    const getExceptionReasonsSelected = async () => {
      if (task?.identifier?.old_assessment_id) {
        const payload = {
          entity_name:
            ENTITY_FIELDS.CASE_PAP_DETAILS.PAP_ELIGIBILITY_ASSESSMENTS,
          select: [STRINGS.EXCEPTION_REASON],
        }
        try {
          const response = await fetchCommunicationIdCorrespondingData(
            Number(task?.identifier?.old_assessment_id),
            payload
          )
          if (response?.data?.exception_reason) {
            setisVisibleIcdCodes(
              response?.data?.exception_reason.includes(STRINGS.DIAGNOSIS)
            )
          }
        } catch (err) {
          console.error(err)
        }
      }
    }

    const fetchDetails = async () => {
      try {
        const payload = {
          entity_name: task?.identifier?.entity_name,
          select: [
            'id',
            ENTITY_FIELDS.CASE_PAP_DETAILS.PAP_ELIGIBILITY_ASSESSMENT_DETAILS,
          ],
          related_entities: {
            c_pap_eligibility_assessment_details_eligibility_assessment: {
              select: ['output_json'],
            },
          },
        }
        const response = await getCaseKeyCaseNameByEntity(
          payload,
          task?.identifier?.entity_name ?? '',
          task?.resource_id ?? ''
        )
        if (response) {
          const details =
            response?.data
              ?.c_pap_eligibility_assessment_details_eligibility_assessment?.[0]
          if (details) {
            const icdCodes =
              details?.output_json?.find(
                (item: DropdownType) => item?.label === STRINGS.ICD_CODES
              )?.value || []
            setValue(element?.keyName, icdCodes)
          }
        }
      } catch (err) {
        console.error(err)
      }
    }

    useEffect(() => {
      getExceptionReasonsSelected()
    }, [task])

    useEffect(() => {
      const fetchCaseDetails = async () => {
        try {
          const payload1 = {
            entity_id: 32,
            select: [
              ENTITY_FIELDS.CASE_PAP_DETAILS.products,
              ENTITY_NAME.PATIENT,
            ],
            page: 0,
            size: 25,
          }
          if (caseId) {
            const response = await getGenericEntityListingAPI(
              payload1 as unknown as GetGenericEntityListingApiType,
              caseId ?? ''
            )
            const patientId = response?.patient?.id || ''
            const productId = response?.products?.id || ''

            if (patientId && productId) {
              const payload2 = {
                entity_name: ENTITY_NAME.PATIENTS,
                page: 0,
                size: 25,
                select: ['c_patient_diagnosis_codes_patient'],
                related_entities: {
                  diagnosis_code: {
                    select: ['description'],
                  },
                  c_patient_diagnosis_codes_patient: {
                    select: ['product_id', 'diagnosis_code'],
                    filters: [
                      {
                        criteria: [
                          {
                            field_name: 'product_id',
                            operation: 'EQUALS',
                            values: [productId],
                          },
                        ],
                      },
                    ],
                  },
                },
              }
              const result = await fetchCommunicationIdCorrespondingData(
                patientId,
                payload2
              )
              if (result) {
                const icdOpt =
                  result?.data?.c_patient_diagnosis_codes_patient
                    ?.filter(
                      (icdCode: FieldValues) => icdCode?.diagnosis_code?.code
                    )
                    ?.map((icdCode: FieldValues) => ({
                      label: icdCode?.diagnosis_code?.code || '',
                      value: icdCode?.diagnosis_code?.code || '',
                    })) || []
                setIcdOptions(icdOpt)
              }
            }
          }
        } catch (err) {
          console.error(err)
        }
      }

      fetchCaseDetails()
      fetchDetails()
    }, [])

    return (
      <>
        {isVisibleIcdCodes ? (
          <div>
            {mode === 'view' ? (
              <div className="font-primary font-light">
                <label
                  htmlFor={element?.keyName}
                  className="text-sm font-normal mb-1 block"
                >
                  {element?.meta?.label}
                </label>
                <div className="text-xs font-extraLight">
                  {getValues(element?.keyName)?.join(', ') || '--'}
                </div>
              </div>
            ) : (
              <ControlledMultiSelect
                options={IcdOptions}
                name={element?.keyName}
                label={element?.meta?.label}
                placeholder={'Select Options'}
                isSearchable={false}
                control={control}
                onChange={(e: DropdownType<string>[]) => {
                  const values = (e || [])?.map((it) => it?.value)
                  setValue(element?.keyName, values)
                }}
                dataQaId={element?.keyName ?? ''}
              />
            )}
          </div>
        ) : null}
      </>
    )
  })

ExceptionIdcCodesCustomComponent.displayName =
  'ExceptionIdcCodesCustomComponent'
